const pre = '/system/';

export default {
    path: '/system',
    title: '系统管理',
    header: 'home',
    custom: 'i-icon-demo i-icon-demo-dashboard',
    children: [
        {
            path: `${pre}log`,
            title: '日志管理'
        },
        {
            path: `${pre}dict`,
            title: '字典管理'
        },{
            path: `${pre}param`,
            title: '参数管理'
        },{
            path: `${pre}token`,
            title: '令牌管理'
        }, {
            path: `${pre}sys-file`,
            title: '文件管理'
        }, {
            path: `${pre}scope`,
            title: '数据权限'
        }, {
            path: `${pre}scopeType`,
            title: '数据权限类型'
        }, {
            path: `${pre}scopeLevel`,
            title: '数据权限级别'
        }, {
            path: `${pre}error`,
            title: '异常管理'
        }, {
            path: `${pre}job`,
            title: '调度管理'
        }
    ]
}
